import { MtAccountPackage } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setAccountPackageList = (accountPackageList: types.AccountPackageList) => ({
    type: inferLiteral(types.ACCOUNT_PACKAGE_LIST),
    accountPackageList,
})
export const setAccountPackageEdit = (accountPackage: MtAccountPackage) => ({
    type: inferLiteral(types.ACCOUNT_PACKAGE_EDIT),
    accountPackage,
})
export const setAccountPackageAllowed = (packageAllowed: number[]) => ({
    type: inferLiteral(types.ACCOUNT_PACKAGE_ALLOWED),
    packageAllowed,
})
export const setAccountPackageSort = (sortColumn: keyof MtAccountPackage, sortOrder: OrderType) => ({
    type: inferLiteral(types.ACCOUNT_PACKAGE_SORT),
    sortColumn,
    sortOrder,
})
export const setAccountPackageReloadList = (value: boolean) => ({
    type: inferLiteral(types.ACCOUNT_PACKAGE_RELOAD_LIST),
    value,
})
export const setAccountPackageReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.ACCOUNT_PACKAGE_RELOAD_EDIT),
    value,
})
